module.exports = __webpack_public_path__ + "static/img/libaohouse.db1d115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/libaohouse.jpg
// module id = PY3/
// module chunks = 16